export default __webpack_public_path__ + "static/media/background.9911104f.webp";